module.exports = __webpack_public_path__ + "static/media/zoom-in.84e7aa55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zoom-in.svg
// module id = 1817
// module chunks = 0